const LOCALE_TO_DAYJS: Record<string, string> = {
  'az-AZ': 'az',
  'de-DE': 'de',
  'es-ES': 'es',
  'es-419': 'es',
  'fr-FR': 'fr',
  'hi-IN': 'hi',
  'pt-BR': 'pt',
  'pt-PT': 'pt',
  'ro-RO': 'ro',
  'ru-RU': 'ru',
  'tr-TR': 'tr',
  'uk-UA': 'uk',
  'it-IT': 'it',
  'en-US': 'en',
  'en-GB': 'en'
};

export default LOCALE_TO_DAYJS;
